import React, { useEffect, useState } from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner, Table,
    CardHeader,Collapse,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,Label,Modal,
    Col,
    Container,
    ModalHeader,
    ModalBody,
  } from "reactstrap";
  import Features from './adminreq/Features.js'
import Vehiclereq from './adminreq/Vehiclereq.js'
import Brandreq from './adminreq/Brandreq.js';

function Tenreqs(props) {
    const [showProcessing , setShowProcessing] = useState(false)
    const [sfshow, setSfshow] = useState(false)
    const [svshow, setSvshow] = useState(false)
    const [sbshow, setSbshow] = useState(false)
    const [data , setData] = useState({
        brand : [],
        vehicle : [],
        feature : []        
    })
    const [vehicle , setVehicle ] = useState({
        reqid: "",
        vid : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}]
      })
    const [features, setFeatures] = useState({
        categoryCode :"", categoryName : "", featureCode : "", en : "", fr : "", ar : "", unit : "", valueRange : [], reqid: ""}
        )
    
    const [selectedbrand, setSelectedBrand] = useState({
            bid : "", bname : {en : "", fr :"", ar : ""},
            blogo : ""
        })
    
          
    const [flen, setFlen] = useState(0)
    const [vlen, setVlen] = useState(0)    
    const [blen, setBlen] = useState(0)  

    useEffect(() => {
        populatedata()
    },[])
    
    
  
    const populatedata = () => {
        setShowProcessing(true)
        props.API.get(`tenant/requests`,{headers: {"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            setShowProcessing(false)    
            
            let vhdata = res.data.vehicle.sort((a, b) => a.rDate > b.rDate ? -1 : 1) 
            let frdata = res.data.feature.sort((a, b) => a.rDate > b.rDate ? -1 : 1) 
            let brdata = res.data.brand.sort((a, b) => a.rDate > b.rDate ? -1 : 1) 
            let uavhd = res.data.feature.filter(g =>  g.astatus === undefined)
            let uavh = res.data.vehicle.filter(g =>  g.astatus === undefined)
            let bavh = res.data.brand.filter(g =>  g.astatus === "Pending")
            setFlen(uavhd.length)
            setVlen(uavh.length)
            setBlen(bavh.length)
          //  console.log(res.data.feature)
         //   console.log(res.data.vehicle)
           setData({brand : brdata, vehicle : vhdata, feature : frdata})
     }).catch(function (error) {
            console.log(error.response.status)
            setShowProcessing(false)
            if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
            }else{
                props.swal("Error fetching request data")
            }
          }) 
    }

    const showFeature = () => {
        return (
            <Modal isOpen={sfshow} size="xl">
                <ModalHeader >
                Request Feature<span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSfshow(false);setFeatures(
                    {  categoryCode :"", categoryName : "",  featureCode : "", en : "", fr : "", ar : "", unit : "", valueRange : [], reqid: ""}
                )}} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Features API={props.API} swal={props.swal} features ={features} populatedata={populatedata}/>
                </ModalBody>
            </Modal>
        )
    }

    const showVehicle = () => {
        return (
            <Modal  isOpen={svshow} size="lg">
                <ModalHeader >
                    Request Vehicles <span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSvshow(false);setVehicle({
                         reqid: "",
                         vid : "",
                         categoryCode : "", 
                         category : {en : "", fr : "", ar : ""},
                         bid : "",
                         blogo : "",
                         bname :   {en : "", fr : "", ar : ""},
                         mname :  {en : "", fr : "", ar : ""},
                         modelyear : {value : "", label :""},
                         notes : "",
                         vtypeCode : "",
                         vtname : {en : "", fr : "", ar : ""},
                         features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}]
                    })}} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Vehiclereq API={props.API} swal={props.swal} vehicle={vehicle} populatedata={populatedata}/>
                </ModalBody>
            </Modal>
        )
    }
    const showBrand = () => {
        return (
            <Modal  isOpen={sbshow} size="lg">
                <ModalHeader >
                    Requested Brand <span style={{float : "right"}}><i className="fa fa-times-circle" aria-hidden="true" style={{float : "right", cursor : "pointer"}} onClick={y => {setSbshow(false);
                    setSelectedBrand({
                        bid : "", bname : {en : "", fr :"", ar : ""},
                        blogo : ""
                    })
                    }} ></i></span>
                </ModalHeader>
                <ModalBody>
                    <Brandreq API={props.API} swal={props.swal} selectedbrand={selectedbrand} populatedata={populatedata}/>
                </ModalBody>
            </Modal>
        )
    }
    const delreq = (stype, reqid) => {
        setShowProcessing(true)
        props.API.post(`tenant/delreq`, {stype , reqid},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
           props.swal(res.data.message)
            if(stype === "Brand"){
                let nlist = data.brand.filter(t => t.reqid !== reqid)
                setData({...data , brand  : nlist})    
            }else if(stype === "Vehicle"){
                let nlist = data.vehicle.filter(t => t.reqid !== reqid)
                setData({...data , vehicle  : nlist})    
            }else if(stype === "Feature"){
                let nlist = data.feature.filter(t => t.reqid !== reqid)
                setData({...data , feature  : nlist})    
            }
            
            setShowProcessing(false)
          //  dispatch(profileFetch(props.user.tuid))
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
            }else{
                props.swal("Error fetching request data")
            }
         })
    }
    
    const approvereq  = (stype, reqid) => {
        setShowProcessing(true)
        props.API.post(`tenant/approvereq`, {stype , reqid},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            
            props.swal(res.data.message)
           populatedata()
            setShowProcessing(false)
          //  dispatch(profileFetch(props.user.tuid))
          }).catch(function (error) {
            setShowProcessing(false)
            console.log(error)
            if(error.response.status === 401){
                props.swal("Unauthorized, please login again.").then(t => {
                    props.history.push(`/auth/login`)
                })   
            }else{
                props.swal("Error fetching request data")
            }
          })
    }




    const retfeat = () => {
        try{
            return (
                data.feature.map((x, key) =>{
                    return (
                        <tr key={key}>
                            <td>{x.tuid}-{x.rBy}</td>
                            <td>{x.categoryName.en}</td>
                            <td>{x.features[0].en}</td>
                            <td>{new Date(x.rDate).toLocaleDateString('en-GB')}</td>
                            <td>{x.astatus !== "Approved" && <i className="fa fa-check-circle-o" aria-hidden="true" style={{color : "green", paddingRight : 10, cursor : "pointer"}} onClick={t => approvereq("Feature", x.reqid)}></i>} <i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setFeatures(x); setSfshow(true)}}></i>&emsp;<i className="fa fa-trash" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 3}} onClick={g => delreq("Feature", x.reqid)}></i></td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }
    const retveh = () => {
        try{
            return (
                data.vehicle.map((x, key) =>{
                 
                    return (
                        <tr key={key}>
                            <td>{x.tuid}-{x.rBy}</td>
                            <td>{x.bname.en}</td>
                            <td>{x.mname.en}</td>
                            <td>{new Date(x.rDate).toLocaleDateString('en-GB')}</td>
                            <td>{x.astatus !== "Approved" && <i className="fa fa-check-circle-o" aria-hidden="true" style={{color : "green", paddingRight : 10, cursor : "pointer"}} onClick={t => approvereq("Vehicle", x.reqid)}></i>}
                                    <i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setVehicle(x); setSvshow(true)}} ></i>&emsp;
                                    <i className="fa fa-trash" aria-hidden="true" style={{float : "right" , cursor : "pointer", marginTop : 3}} onClick={g => delreq("Vehicle", x.reqid)}></i></td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }

    const retbra = () => {
        try{
            return (
                data.brand.map((x, key) =>{
                 
                    return (
                        <tr key={key}>
                            <td>{x.tuid}-{x.rBy}</td>
                            <td>{new Date(x.rDate).toLocaleDateString('en-GB')}</td>
                            <td>{x.astatus !== "Approved" && <i className="fa fa-check-circle-o" aria-hidden="true" style={{color : "green", paddingRight : 10, cursor : "pointer"}} onClick={t => approvereq("Brand", x.reqid)}></i>}
                                                             <i className="fa fa-info-circle" aria-hidden="true" style={{cursor : "pointer"}} onClick={o => {setSelectedBrand(x); setSbshow(true)}} ></i>&emsp;
                                                             <i className="fa fa-trash" aria-hidden="true" style={{float : "right" , cursor : "pointer", marginTop : 3}} onClick={g => delreq("Brand", x.reqid)}>
                                                                </i>
                            </td>
                        </tr>
                    )
                })
            )
        }catch(e){

        }
       
    }

    return (
                <div className='content'>
                {showProcessing && props.Spin } 

                {showVehicle()}
                {showFeature()}
                {showBrand()}
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                    <Row>
                                        <Col><h6>Features</h6> </Col>
                                        <Col><center>Total : <h6>{data.feature.length}</h6></center></Col>
                                        <Col><center>Pending :  <h6>{flen}</h6> </center></Col>
                                    </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <CardBody>
                                    <Row>
                                        <Col><h6>Model</h6> </Col>
                                        <Col><center>Total : <h6>{data.vehicle.length}</h6></center></Col>
                                        <Col><center>Pending :<h6 >{vlen}</h6></center></Col>
                                    </Row> 
                                    </CardBody>
                                </Card>
                            </Col>
                             
                             <Col>    
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col><h6>Brands</h6> </Col>
                                        <Col><center>Total : <h6>{data.brand.length}</h6></center></Col>
                                        <Col><center>Pending :<h6 >{blen}</h6></center></Col>
                                    </Row> 
                                </CardBody>
                                </Card>   
                            </Col>
                       
                        </Row>

                        <Row>
                            <Col>
                            <Card>
                                <CardBody>
                                <div style={{
                                        maxHeight: '550px',
                                        overflowY: 'auto'
                                    }}>    
                                <Table>
                                    <thead  style={{position : "sticky", top : 0}}>
                                        <tr>
                                            <th>By</th>
                                            <th>Category</th>
                                            <th>Feature</th>
                                            <th>Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{position : "inherit", overflowY : "auto"}}>
                                        {
                                            retfeat()
                                        }
                                    </tbody>
                                </Table>
                                </div>
                                </CardBody>
                            </Card>
                            
                            </Col>
                            <Col>
                                <Card>
                                    <CardBody>
                                    <div style={{
                                        maxHeight: '550px',
                                        overflowY: 'auto'
                                    }}> 
                                    <Table >
                                    <thead  style={{position : "sticky", top : 0}}>
                                        <tr>
                                             <th>By</th>
                                            <th>Brand</th>
                                            <th>Model</th>
                                            <th>Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{position : "inherit", overflowY : "auto"}}>
                                        {
                                            retveh()
                                        }
                                    </tbody>
                                </Table>
                                </div>
                                    </CardBody>
                                </Card>
                            
                            </Col>
                             
                             <Col>
                            <Card>
                                <CardBody>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Brand</th>
                                            <th>Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            retbra()
                                        }
                                    </tbody>
                                </Table>
                                </CardBody>
                            </Card>
                            
                            </Col>
                            
                        </Row>    
            
            
                  </div>
    );
}

export default Tenreqs; <h1>Tenant Requests</h1>